"use client"

import styled, { css } from "styled-components"

import { Button as BaseButton } from "@/components/Button"
import { Paragraph as BaseParagraph } from "@/components/Paragraph"

export const Main = styled.div`
  ${({ theme }) => {
    const { colors, zIndex } = theme

    return css`
      width: 100vw;
      height: 100vh;
      position: fixed;
      bottom: 0;
      z-index: ${zIndex.warning};
      background-color: ${colors.content.bg};
    `
  }}
`

export const ContentContainer = styled.div`
  ${({ theme }) => {
    const { spaces, breakpoints } = theme

    return css`
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      margin-top: ${spaces.large};
      gap: ${spaces.big};

      @media (max-height: ${breakpoints.ultrasmall}) {
        gap: ${spaces.large};
      }
    `
  }}
`

export const Paragraph = styled(BaseParagraph)`
  ${({ theme }) => {
    const { big } = theme.spaces
    const { oneAndHalf } = theme.fonts.lineHeight

    return css`
      line-height: ${oneAndHalf};
      margin: 0 ${big};
      text-align: center;
    `
  }}
`

export const LinksContainer = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spaces.normal};
`

export const StyledLink = styled(BaseButton)`
  font-weight: ${({ theme }) => theme.fonts.weight.light};
`

export const StyledButton = styled(BaseButton)`
  ${({ theme }) => {
    const { xtrasmall } = theme.spaces
    const { size, weight } = theme.fonts
    return css`
      font-weight: ${weight.regular};
      font-size: ${size.normal};

      svg {
        margin-right: ${xtrasmall};
        font-size: ${size.heading3};
      }
    `
  }}
`
